module.exports = __webpack_public_path__ + "img/efa29.d234272b.svg";